export const PRODUCT_CATEGORIES = [
    { id: 1, name: "Hardware" },
    { id: 2, name: "Software" },
    { id: 3, name: "Services" },
    { id: 4, name: "Peripherals" },
    { id: 5, name: "Network Equipment" },
    { id: 6, name: "Mobile Devices" },
    { id: 7, name: "Computers" },
    { id: 8, name: "Desktops" },
    { id: 9, name: "Laptops" },
    { id: 10, name: "Tablets" },
    { id: 11, name: "Mice" },
    { id: 12, name: "Keyboards" },
    { id: 13, name: "Monitors" },
    { id: 14, name: "Printers" },
    { id: 15, name: "Scanners" },
    { id: 16, name: "Speakers" },
    { id: 17, name: "Headphones" },
    { id: 18, name: "Webcams" },
    { id: 19, name: "External Hard Drives" },
    { id: 20, name: "Flash Drives" },
    { id: 21, name: "Routers" },
    { id: 22, name: "Switches" },
    { id: 23, name: "Access Points" },
    { id: 24, name: "Smartphones" },
    { id: 25, name: "Smartwatches" },
    { id: 26, name: "Operating Systems" },
    { id: 27, name: "Applications" },
    { id: 28, name: "Security Software" },
    { id: 29, name: "Cloud Computing" },
    { id: 30, name: "Web Hosting" },
    { id: 31, name: "Data Center" },
    { id: 32, name: "IT Support" },
    { id: 33, name: "Digital Marketing" },
    { id: 34, name: "Gaming Gear" },
    { id: 35, name: "Smartphone Accessories" },
    { id: 36, name: "Software Licenses" },
    { id: 37, name: "Servers" },
    { id: 38, name: "Storage" },
];
